module.exports = __webpack_public_path__ + "media/header-wave.ad7bb828.webm";